'use strict';

/**
 * Ip utils.
 */ const ipUtils = ()=>{
    /**
     * Convert an ip address string to an array of its parts.
     */ const convertToIpParts = (ipAddress)=>{
        return ipAddress.split('.').map((part)=>parseInt(part.trim(), 10));
    };
    /**
     * Check if ip addresses are equal.
     */ const isIpEqual = (firstIp, secondIp)=>{
        return firstIp === secondIp;
    };
    /**
     * Checks if the first ip address is less than the second ip address.
     */ // eslint-disable-next-line sonarjs/cognitive-complexity
    const isIpLessThan = (firstIp, secondIp)=>{
        // break early if the two ips are equal
        if (isIpEqual(firstIp, secondIp)) {
            return false;
        }
        const firstIpParts = convertToIpParts(firstIp);
        const secondIpParts = convertToIpParts(secondIp);
        // iterate through the ip address segments
        for(let i = 0; i < 4; i++){
            const currentFirstSegment = firstIpParts[i];
            const currentSecondSegment = secondIpParts[i];
            // If this is our first iteration,
            // make sure the first segment is less than the first segment of the second ip
            if (i === 0) {
                // ex: 12.X.X.X < 13.X.X.X
                if (currentFirstSegment < currentSecondSegment) {
                    return true;
                }
                // ex: 13.X.X.X > 12.X.X.X
                if (currentFirstSegment > currentSecondSegment) {
                    return false;
                }
            }
            // If the last segments were equal,
            // make sure that the current segment is less than the current segment of the second ip
            const previousFirstSegment = firstIpParts[i - 1];
            const previousSecondSegment = secondIpParts[i - 1];
            if (previousFirstSegment === previousSecondSegment) {
                // ex: 12.1.5.X < 12.1.6.X
                if (currentFirstSegment < currentSecondSegment) {
                    return true;
                }
                // ex: 12.1.6.X < 12.1.5.X
                if (currentFirstSegment > currentSecondSegment) {
                    return false;
                }
            }
        }
        return true;
    };
    /**
     * Checks if the first ip address is greater than the second ip address.
     */ const isIpGreaterThan = (firstIp, secondIp)=>{
        return !isIpEqual(firstIp, secondIp) && !isIpLessThan(firstIp, secondIp);
    };
    /**
     * Checks if the ip address value is within range, value is inclusive.
     */ const isIpInRangeInclusive = (value, min, max)=>{
        return (isIpGreaterThan(value, min) || isIpEqual(value, min)) && (isIpLessThan(value, max) || isIpEqual(value, max));
    };
    /**
     * Checks if the ip address value is within range, value is exclusive.
     */ const isIpInRangeExclusive = (value, min, max)=>{
        return isIpGreaterThan(value, min) && isIpLessThan(value, max);
    };
    return {
        convertToIpParts,
        isIpLessThan,
        isIpEqual,
        isIpGreaterThan,
        isIpInRangeInclusive,
        isIpInRangeExclusive
    };
};

exports.ipUtils = ipUtils;
//# sourceMappingURL=ipAddress.utils.js.map
